module.exports = __webpack_public_path__ + "open-sans-bold.49a3d5afd563a8a3bbed.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans-bold.woff
// module id = 703
// module chunks = 2